<template>
  <div class="container">
    <h1>Work Order - {{this.$route.params.id}}</h1>
    <div class="row">
      <div class="col-md-6">
        <form>
          <div class="form-group">
            <label>Date</label>
            <input type="text" class="form-control" v-model="readableDate">
          </div>
        </form>
      </div>
      <div class="col-md-6">
        <form>
          <div class="form-group">
            <label>Invoice Number</label>
            <input type="text" class="form-control" v-model="workorder.invoiceNumber">
          </div>
        </form>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <form>
          <div class="form-group">
            <label>Call taken by</label>
            <input type="text" class="form-control" v-model="workorder.callTakenBy">
          </div>
        </form>
      </div>
      <div class="col-md-6">
        <form>
          <div class="form-group">
            <label>Date of request</label>
            <input type="text" class="form-control" v-model="readableRequestDate">
          </div>
        </form>
      </div>
    </div>
    <div class="row">
      <div class="col-md-4">
        <form>
          <div class="form-group">
            <label>Customer Name</label>
            <input type="text" class="form-control" v-model="workorder.customerName">
          </div>
        </form>
      </div>
      <div class="col-md-4">
        <form>
          <div class="form-group">
            <label>Customer Email</label>
            <input type="email" class="form-control" v-model="workorder.customerEmail">
          </div>
        </form>
      </div>
      <div class="col-md-4">
        <form>
          <div class="form-group">
            <label>Customer Phone Number</label>
            <input type="text" class="form-control" v-model="workorder.customerPhoneNumber">
          </div>
        </form>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <form>
          <div class="form-group">
            <label>Address</label>
            <input type="text" class="form-control" v-model="workorder.address">
          </div>
        </form>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <form>
          <div class="form-group">
            <label>Service Requested By</label>
            <input type="text" class="form-control" v-model="workorder.serviceRequestedBy">
          </div>
        </form>
      </div>
      <div class="col-md-6">
        <form>
          <div class="form-group">
            <label>Contact Name</label>
            <input type="text" class="form-control" v-model="workorder.contactName">
          </div>
        </form>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <form>
          <div class="form-group">
            <label>Machine</label>
            <input type="text" class="form-control" v-model="workorder.machine">
          </div>
        </form>
      </div>
      <div class="col-md-3">
        <form>
          <div class="form-group">
            <label>Machine Number</label>
            <input type="text" class="form-control" v-model="workorder.machineNumber">
          </div>
        </form>
      </div>
      <div class="col-md-3">
        <form>
          <div class="form-group">
            <label>Serial Number</label>
            <input type="text" class="form-control" v-model="workorder.serialNumber">
          </div>
        </form>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <form>
          
        </form>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <table class="table table-striped">
          <thead>
            <tr>
              <th scope="col">Date</th>
              <th scope="col">SAT/OT</th>
              <th scope="col">Engineer</th>
              <th scope="col">Arrived</th>
              <th scope="col">Departed</th>
              <th scope="col">Lunch</th>
              <th scope="col">Primary Work Completed</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td>Y/N</td>
              <td></td>
            </tr>
            <tr>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td>Y/N</td>
              <td></td>
            </tr><tr>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td>Y/N</td>
              <td></td>
            </tr><tr>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td>Y/N</td>
              <td></td>
            </tr><tr>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td>Y/N</td>
              <td></td>
            </tr><tr>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td>Y/N</td>
              <td></td>
            </tr><tr>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td>Y/N</td>
              <td></td>
            </tr><tr>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td>Y/N</td>
              <td></td>
            </tr><tr>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td>Y/N</td>
              <td></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
      <div class="row">
      <div class="col-md-12">
        <label>Parts/ Supplies Needed</label>
        <table class="table table-striped">
          <thead>
            <tr>
              <th scope="col">Quantity</th>
              <th scope="col">Part/Supply Used</th>
              <th scope="col">Manufacturer</th>
              <th scope="col">Price</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <form>
          <div class="form-group">
            <label>Work Completed</label>
            <textarea class="form-control"></textarea>
          </div>
        </form>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <form>
          <div class="form-group">
            <label>Notes or Comments</label>
            <textarea class="form-control"></textarea>
          </div>
        </form>
      </div>
    </div>
    <div class="row">
      <div class="col-md-8">
        <form>
          <div class="form-group">
            <label>Work Order For</label>
            <input type="text" class="form-control">
          </div>
        </form>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <form>
          <div class="form-group">
            <label>Machine</label>
            <input type="text" class="form-control">
          </div>
        </form>
      </div>
      <div class="col-md-6">
        <form>
          <div class="form-group">
            <label>Problem/Project</label>
            <input type="text" class="form-control">
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import firebase from 'firebase';
import moment from 'moment';

export default {
  props: ["workorderPath"],
  data () {
    return {
      workorder: null
    }
  },
  computed: {
    readableDate() {
      if (this.workorder && this.workorder.date) {
        return moment(this.workorder.date).format('MM/DD/YYYY');         
      }
      return '';
    },
    readableRequestDate() {
      if (this.workorder && this.workorder.requestDate) {
        return moment(this.workorder.requestDate).format('MM/DD/YYYY');
      }
      return '';
    }
  },
  created () {
    const workordersDB = firebase.firestore().collection('workorders');

    workordersDB.doc(this.$route.params.id).get().then(docs => {
        this.workorder = docs.data();
    }).catch(err => {
        console.log(err)
    })
  }
}
</script>